export const groupBy = (key: string, arr: any[]) =>
    arr.reduce((cache: { [key: string]: any[] }, element: { [key: string]: any }) => {
        const property = element[key];
        if (property in cache) {
            return { ...cache, [property]: cache[property].concat(element) };
        }
        return { ...cache, [property]: [element] };
    }, {});
